import axios from 'axios';
import Vue from 'vue';

let url = process.env.VUE_APP_BASE_URL !== undefined ? process.env.VUE_APP_BASE_URL : 'https://addmasadminapi.antidoping.dk/api';

if (process.env.NODE_ENV === 'development') {
    url = 'https://addmasadminapi-test.antidoping.dk/api';
}

const ajax = axios.create({
    baseURL: url,
});

ajax.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },

    error => Promise.reject(error),
);


ajax.interceptors.response.use(response => response.data, (error) => {
    const data = error.response && error.response.data;
    const isPlainData = data && typeof data === 'object' && !(data instanceof Blob);

    let msg = isPlainData ? (data.message || data) : null;
    msg = (msg && msg.error) || msg;
    msg = (msg && msg.trim && msg.trim()) || 'Der skete en fejl';

    Vue.prototype.$snotify.error(msg);

    return Promise.reject(error);
});

export default ajax;
